import { ErrorMessage, Field, Form, Formik } from "formik"
import { FC } from "react"
import { SelectField } from "src/sections/capterra/ContactForm"
import { ReactComponent as ArrowIcon } from '../../assets/icons/button-arrow.svg'
import { patternGenerator } from "../Patterns/patternsGenerator"
import { comarketingOpportunitiesOptions, experienceWorkingCRMOptions } from "./constants"
import RSVPLogo from '../../assets/images/rsvp/peoplevine-rsvp-logo-white-orange.png'
import './RSVPForm.scss'

const patterns = patternGenerator({ quantity: 6, theme: "dark" })

export const RSVPForm: FC = () => {
  const initialValues = {
    companyName: '',
    website: '',
    companyOverview: '',
    primaryContactName: '',
    primaryContactTitle: '',
    primaryContactEmail: '',
    primaryContactPhone: '',
    address: '',
    partnershipCommunity: '',
    experienceWorking: '',
    integratePVPlatform: '',
    clientOpportunities: '',
    comarketingOpportunities: '',
    referencesPastClients: '',
    aditionalInformation: ''

  }

  return (
    <div className='main-contact' id='capterra-contact' role={"presentation"}>
      <div className='ornament-block'>{patterns}</div>
      <div className='container'>
        <div className='main-contact__wrapper'>
          <div className="main-contact__image">
            <img src={RSVPLogo} alt='RSVP Logo' />
          </div>
          <h2 className='main-contact__title'>RSVP Community - Partner Application</h2>
          <div className='main-form-block'>
            <Formik initialValues={initialValues} onSubmit={() => {}}>
              {form => (
                <Form className='main-login-form'>
                  <div className='login-form__wrapper'>
                    <p className='card-list-heading spacer-v2'>Company Information</p>
                    <div className='login-form__row'>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='companyName'>
                                Company Name
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='companyName' 
                                placeholder='Enter company name' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.companyName && form?.touched.companyName ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='companyName' component='span' className='login-form__error-message' />
                      </div>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='website'>
                                Website
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='website' 
                                placeholder='Enter website' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.website && form?.touched.website ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='website' component='span' className='login-form__error-message' />
                      </div>
                    </div>
                    <div className='login-form__row'>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='companyOverview'>
                                Company Overview
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='companyOverview' 
                                placeholder='Enter company overview' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.companyOverview && form?.touched.companyOverview ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='companyOverview' component='span' className='login-form__error-message' />
                      </div>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='primaryContactName'>
                                Primary Contact Name
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='primaryContactName' 
                                placeholder='Enter primary contact name' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.primaryContactName && form?.touched.primaryContactName ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='primaryContactName' component='span' className='login-form__error-message' />
                      </div>
                    </div>
                    <div className='login-form__row'>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='primaryContactTitle'>
                                Primary Contact Title
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='primaryContactTitle' 
                                placeholder='Enter primary contact title' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.primaryContactTitle && form?.touched.primaryContactTitle ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='primaryContactTitle' component='span' className='login-form__error-message' />
                      </div>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='primaryContactEmail'>
                                Primary Contact Email
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='primaryContactEmail' 
                                placeholder='Enter primary contact email' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.primaryContactEmail && form?.touched.primaryContactEmail ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='primaryContactEmail' component='span' className='login-form__error-message' />
                      </div>
                    </div>
                    <div className='login-form__row'>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='primaryContactPhone'>
                                Primary Contact Phone Number
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='primaryContactPhone' 
                                placeholder='Enter primary contact phone number' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.primaryContactPhone && form?.touched.primaryContactPhone ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='primaryContactPhone' component='span' className='login-form__error-message' />
                      </div>
                      <div className='login-form__input'>
                        <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='address'>
                                Address (Street, City, State, Country)
                                <span className='login-form__label-required'> *</span>
                            </label>
                            <Field 
                                type='text'
                                name='address' 
                                placeholder='Enter address' 
                                autoComplete='off' 
                                className={`login-form__inputfield ${form?.errors.address && form?.touched.address ? 'login-form__inputfield--error' : ''}`} 
                            />
                        </div>
                        <ErrorMessage name='address' component='span' className='login-form__error-message' />
                      </div>
                    </div>


                    <p className='card-list-heading spacer-v2'>Alignment with Peoplevine's Partnership Model </p>
                    <div className='login-form__input-inner-box'>
                      <div className=''>
                        <div className='login-form__input'>
                          <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='partnershipCommunity'>
                                What excites you most about joining the Peoplevine RSVP Partnership Community?
                              <span className='login-form__label-required'> *</span>
                            </label>
                            <Field
                              type='text'
                              className={`login-form__inputfield 
                        ${form?.errors.partnershipCommunity && form?.touched.partnershipCommunity && 'login-form__inputfield--error'}`}
                              name='partnershipCommunity'
                              placeholder='partnership community'
                              autoComplete="off"
                            />
                          </div>
                          <ErrorMessage name='partnershipCommunity' component='span' className='login-form__error-message' />
                        </div>
                      </div>
                    </div>

                    <div className='login-form__input-inner-box'>
                        <div className=''>
                        <div className='login-form__input'>
                            <div className='login-form__input-inner-box'>

                            <Field name={'experienceWorking'} placeholder='Do you have any experience working with CRM platforms or membership management technology? ' component={SelectField} required={true} options={experienceWorkingCRMOptions} />
                            </div>
                            <ErrorMessage name='experienceWorking' component='span' className='login-form__error-message' />
                        </div>
                        </div>
                    </div>
                    
                    <div className='login-form__input-inner-box'>
                      <div className=''>
                        <div className='login-form__input'>
                          <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='integratePVPlatform'>
                                How do you plan to integrate Peoplevine’s platform into your services to benefit your clients? 
                              <span className='login-form__label-required'> *</span>
                            </label>
                            <Field
                              type='text'
                              className={`login-form__inputfield 
                        ${form?.errors.integratePVPlatform && form?.touched.integratePVPlatform && 'login-form__inputfield--error'}`}
                              name='integratePVPlatform'
                              placeholder='partnership community'
                              autoComplete="off"
                            />
                          </div>
                          <ErrorMessage name='integratePVPlatform' component='span' className='login-form__error-message' />
                        </div>
                      </div>
                    </div>

                    <p className='card-list-heading spacer-v2'>Referral and Growth Strategy </p>
                    <div className='login-form__input-inner-box'>
                      <div className=''>
                        <div className='login-form__input'>
                          <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='clientOpportunities'>
                                How do you plan to leverage the Peoplevine RSVP Partnership Community to drive new client opportunities and referrals? 
                              <span className='login-form__label-required'> *</span>
                            </label>
                            <Field
                              type='text'
                              className={`login-form__inputfield 
                        ${form?.errors.clientOpportunities && form?.touched.clientOpportunities && 'login-form__inputfield--error'}`}
                              name='clientOpportunities'
                              placeholder='partnership community'
                              autoComplete="off"
                            />
                          </div>
                          <ErrorMessage name='clientOpportunities' component='span' className='login-form__error-message' />
                        </div>
                      </div>
                    </div>

                    <div className='login-form__input-inner-box'>
                        <div className=''>
                        <div className='login-form__input'>
                            <div className='login-form__input-inner-box'>

                            <Field name={'comarketingOpportunities'} placeholder='Are you open to co-marketing opportunities with Peoplevine (e.g., joint webinars, case studies, promotional materials)?' component={SelectField} required={true} options={comarketingOpportunitiesOptions} />
                            </div>
                            <ErrorMessage name='comarketingOpportunities' component='span' className='login-form__error-message' />
                        </div>
                        </div>
                    </div>
                    <p className='card-list-heading spacer-v2'> Additional Information and References </p>
                    
                    <div className='login-form__input-inner-box'>
                      <div className=''>
                        <div className='login-form__input'>
                          <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='referencesPastClients'>
                                Please provide any references from past clients in the luxury or membership-driven sectors 
                              <span className='login-form__label-required'> *</span>
                            </label>
                            <Field
                              type='text'
                              className={`login-form__inputfield 
                        ${form?.errors.referencesPastClients && form?.touched.referencesPastClients && 'login-form__inputfield--error'}`}
                              name='referencesPastClients'
                              placeholder='references from past clients'
                              autoComplete="off"
                            />
                          </div>
                          <ErrorMessage name='referencesPastClients' component='span' className='login-form__error-message' />
                        </div>
                      </div>
                    </div>
                    <div className='login-form__input-inner-box'>
                      <div className=''>
                        <div className='login-form__input'>
                          <div className='login-form__input-inner-box'>
                            <label className='login-form__label' htmlFor='aditionalInformation'>
                                Do you have any additional information you’d like to share with us?
                              <span className='login-form__label-required'> *</span>
                            </label>
                            <Field
                              type='text'
                              className={`login-form__inputfield 
                        ${form?.errors.aditionalInformation && form?.touched.aditionalInformation && 'login-form__inputfield--error'}`}
                              name='aditionalInformation'
                              placeholder='aditional information'
                              autoComplete="off"
                            />
                          </div>
                          <ErrorMessage name='aditionalInformation' component='span' className='login-form__error-message' />
                        </div>
                      </div>
                    </div>


                  </div>
                  <div className='login-form__button'>
                    <button type='submit' disabled={form?.isSubmitting}>
                      Get free demo
                      <ArrowIcon />
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}
